import { render, staticRenderFns } from "./ProductRating.vue?vue&type=template&id=f07795f4&scoped=true"
import script from "./ProductRating.vue?vue&type=script&lang=js"
export * from "./ProductRating.vue?vue&type=script&lang=js"
import style1 from "./ProductRating.vue?vue&type=style&index=1&id=f07795f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07795f4",
  null
  
)

export default component.exports